<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant
            type="search"
            name="plantCd"
            v-model="searchParam.plantCd"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- (기간)조치완료 요청일 -->
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            label="LBL0001410"
            name="actionCompleteRequestDates"
            v-model="searchParam.actionCompleteRequestDates"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 업무 -->
          <c-select
            codeGroupCd="IBM_TASK_TYPE_CD"
            :rejectItems="['ITT0000145']"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ibmTaskTypeCd"
            label="LBLWORK"
            v-model="searchParam.ibmTaskTypeCd"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행단계 -->
          <c-select
            stepperGrpCd="IBM_STEP_CD"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="ibmStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.ibmStepCd"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 요청부서 -->
          <c-dept
            :isFirstValue="false"
            type="search"
            label="LBL0001421"
            name="improveRequestDeptCd"
            v-model="searchParam.improveRequestDeptCd"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 조치부서 -->
          <c-dept
            type="search"
            label="LBL0001417"
            name="actionDeptCd"
            v-model="searchParam.actionDeptCd"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 개선구분 -->
          <c-select
            codeGroupCd="IBM_CLASS_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ibmClassCd"
            label="LBL0001411"
            v-model="searchParam.ibmClassCd"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-checkbox
            :isFlag="true"
            falseLabel="All"
            label="지연된 업무 확인"
            name="overFlag"
            v-model="searchParam.overFlag"
            @input="getList"
          />
        </div>
      </template>
    </c-search-box>
    <!-- 개선 목록 -->
    <c-table
      ref="table"
      title="지연된 업무 확인"
      :filtering="false"
      :columnSetting="false"
      :isFullScreen="false"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      rowKey="sopImprovementId"
      :selection="popupParam.type"
      @linkClick="linkClick"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <!-- 검색 -->
          <!-- <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" /> -->
          <!-- 선택 -->
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'actionCompleteRequestDate'">
          <span
            :style="
              props.row.approvalStatusCd === 'ASC9999999'
                ? 'text-decoration: line-through'
                : ''
            "
          >
            {{ props.row.actionCompleteRequestDate }}
            <!-- 지연 -->
            <q-badge
              v-if="
                props.row.completeDateOver > 0 &&
                props.row.ibmStepCd !== 'IS00000001' &&
                props.row.approvalStatusCd !== 'ASC9999999'
              "
              color="negative"
              :label="$label('LBL0001414')"
              class="blinking"
            />
          </span>
          <span v-if="props.row.approvalStatusCd === 'ASC9999999'">
            👉 {{ props.row.targetDate }}
          </span>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "imprPop",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          type: "single",
          plantCd: "",
        };
      },
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        actionCompleteRequestDates: [],
        ibmTaskTypeCd: null,
        stepCd: null,
        improveRequestDeptCd: "",
        actionDeptCd: "",
        actionFlag: "D",
        overFlag: "N",
        ibmClassCd: null,
      },
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "LBLPLANT",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "ibmTaskTypeName",
            field: "ibmTaskTypeName",
            // 업무
            label: "LBLWORK",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "ibmTitle",
            field: "ibmTitle",
            // 제목
            label: "LBLTITLE",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "link",
          },
          {
            name: "ibmStepName",
            field: "ibmStepName",
            // 진행단계
            label: "LBLSTEPPROGRESS",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "improveRequestDeptName",
            field: "improveRequestDeptName",
            // 요청부서
            label: "LBL0001421",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "improveRequestContents",
            field: "improveRequestContents",
            // 요청정보
            label: "LBL0001420",
            align: "left",
            style: "width:200px",
            type: "html",
            sortable: true,
          },
          {
            name: "actionCompleteRequestDate",
            field: "actionCompleteRequestDate",
            // 조치완료 요청일
            label: "LBL0001419",
            align: "center",
            style: "width:100px",
            type: "custom",
            sortable: true,
          },
          {
            name: "approvalStatusName",
            field: "approvalStatusName",
            // 지연 결재
            label: "LBL0001418",
            align: "center",
            sortable: true,
            style: "width:90px",
          },
          {
            name: "actionDeptName",
            field: "actionDeptName",
            // 조치부서
            label: "LBL0001417",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "actionUserNames",
            field: "actionUserNames",
            // 조치자
            label: "LBL0001416",
            align: "left",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "actionCompleteDate",
            field: "actionCompleteDate",
            // 조치완료일
            label: "LBL0001426",
            align: "center",
            style: "width:90px",
            sortable: true,
          },
        ],
        data: [],
        height: "500px",
      },
      editable: true,
      listUrl: "",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.ibm.improve.list.url;
      // code setting
      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd;
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      if (!row || row.ibmClassCd == "IC00000001") {
        // 즉시조치
        this.popupOptions.title = "LBL0001415"; // 개선 상세
        this.popupOptions.isFull = true;
        this.popupOptions.param = {
          sopImprovementId: row.sopImprovementId,
          ibmTaskTypeCd: row.ibmTaskTypeCd,
        };
        this.popupOptions.target = () => import(`${"./imprDetail.vue"}`);
      } else {
        this.popupOptions.title = "LBLIMMEDIATE";
        this.popupOptions.isFull = false;
        this.popupOptions.param = {
          sopImprovementId: row.sopImprovementId,
          ibmTaskTypeCd: row.ibmTaskTypeCd,
        };
        this.popupOptions.target = () =>
          import(`${"@/pages/sop/ibm/imprImmDetail.vue"}`);
        this.popupOptions.width = "80%";
      }
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습닏다.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === "single") {
        this.$emit("closePopup", [row]);
      }
    },
  },
};
</script>
